module.exports = __webpack_public_path__ + "static/media/restaurant.b06d9ff8.svg";